export default "__VITE_ASSET__Vtnn_RLv__"